import { useEffect } from "react";
import { Field, useFormState } from "react-final-form";
import { useIntl } from "react-intl";
import Section from "../../../common/section";
import * as Validations from "../../../common/form/validator";
import {
  DropdownInput,
  TextInput,
  MultiSelectInput,
} from "../../../common/fields";
import {
  LearningObjectConstants,
  GlobalConstants,
} from "../../../../constants";

const LearningObjectDetailsForm = ({
  disabled = false,
  setUploadType,
  uploadDetails = null,
  readOnly = false,
  allowedLanguages = ["en"],
  certificates,
}) => {
  const intl = useIntl();
  const formState = useFormState();

  useEffect(() => {
    if (formState?.values?.type) {
      setUploadType(formState?.values?.type);
    }
  }, [formState?.values?.type, setUploadType]);

  const getAllSupportedLanguages = () => {
    return GlobalConstants.LANGUAGES.filter(
      (lang) => allowedLanguages.includes(lang.code) || lang.code === "en"
    ).map((language) => ({
      ...language,
      id: language.code,
      name: language.name,
    }));
  };

  return (
    <div>
      <Section title="identity">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="name"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "name",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "name",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="type"
              component={DropdownInput}
              options={LearningObjectConstants.TYPES}
              label={intl.formatMessage({
                id: "type",
              })}
              placeholder={intl.formatMessage({
                id: "type",
              })}
              required
              disabled={disabled}
              readOnly={uploadDetails ? true : false || readOnly}
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          {/* <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="maxAttemptsAllowed"
              component={TextInput}
              type="number"
              label={intl.formatMessage({
                id: "max_attempts_allowed",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "max_attempts_allowed",
              })}
              required
              validate={Validations.composeValidators(
                Validations.required,
                Validations.numberGreater0
              )}
            />
          </div> */}
          {/* <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="pointsOnCompletion"
              component={TextInput}
              type="number"
              label={intl.formatMessage({
                id: "point_on_completion",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "point_on_completion",
              })}
              required
              validate={Validations.composeValidators(
                Validations.required,
                Validations.numberPositive
              )}
              readOnly={readOnly}
            />
          </div> */}
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="maxTimeInSecsAllowed"
              component={TextInput}
              type="number"
              label={intl.formatMessage({
                id: "max_time_in_seconds",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "max_time_in_seconds",
              })}
              required
              validate={Validations.composeValidators(
                Validations.required,
                Validations.numberGreater0
              )}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="certificateId"
              component={DropdownInput}
              label={intl.formatMessage({
                id: "certficate",
              })}
              placeholder={intl.formatMessage({
                id: "certficate",
              })}
              disabled={disabled}
              options={certificates.map((item) => ({
                name: item.name,
                id: item.id,
                value: item.id,
                i18n: false,
              }))}
            />
          </div>
          {/* <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="tags"
              component={Tags}
              type="text"
              label={intl.formatMessage({
                id: "tags",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "tags",
              })}
            />
          </div> */}
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="supportedLanguages"
              component={MultiSelectInput}
              options={getAllSupportedLanguages()}
              label={intl.formatMessage({
                id: "supported_languages",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "supported_languages",
              })}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default LearningObjectDetailsForm;
